import React from "react";
import { ArrowRight, FileText } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function PrecisionInRecovery() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="precision-in-recovery" className="relative w-full overflow-hidden bg-background py-16 lg:py-24">
      {}
      <div className="pointer-events-none absolute inset-0 z-0 opacity-[0.03]">
        <svg className="h-full w-full" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <pattern id="grid-pattern" width="40" height="40" patternUnits="userSpaceOnUse">
              <path d="M 40 0 L 0 0 0 40" fill="none" stroke="currentColor" strokeWidth="1" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#grid-pattern)" />
        </svg>
      </div>

      <div className="container relative z-10 mx-auto px-4 md:px-6">
        <div className="grid gap-12 lg:grid-cols-12 lg:gap-8 lg:items-center">
          {}
          <div ref={ref} className={`lg:col-span-7 flex flex-col justify-center transition-all duration-1000 ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`}>
            <h1 className="font-serif text-5xl font-bold tracking-tight text-primary sm:text-6xl md:text-7xl lg:leading-[1.1]">Walking Alongside You in Recovery</h1>
            <p className="mt-6 max-w-2xl text-lg text-muted-foreground md:text-xl leading-relaxed">At Resolve Clinical Services, we provide compassionate, NDIS-focused support for people living with disability.<div><br /></div></p>

            <div className="mt-8 flex flex-col gap-4 sm:flex-row">
              <Button asChild size="lg" className="h-12 px-8 text-base shadow-md">
                <Link to="/ContactPage">
                  Start Your Journey
                  <ArrowRight className="ml-2 h-4 w-4" />
                </Link>
              </Button>
              <Button asChild variant="outline" size="lg" className="h-12 px-8 text-base bg-background/50 backdrop-blur-sm hover:bg-accent/50">
                <Link to="/OurModelPage">
                  <FileText className="mr-2 h-4 w-4" />
                  View Our Model
                </Link>
              </Button>
            </div>

            {}
            <div className="mt-10 flex items-center gap-4 text-sm text-muted-foreground">
              <div className="flex items-center gap-2">
                <div className="h-1.5 w-1.5 rounded-full bg-primary/60" />
                <span>South Australia Based</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="h-1.5 w-1.5 rounded-full bg-primary/60" />
                <span>Local, Family-Owned &amp; Operated.</span>
              </div>
              
            </div>
          </div>

          {}
          <div className="lg:col-span-5 relative mt-8 lg:mt-0">
            <div className={`relative aspect-[3/4] w-full overflow-hidden rounded-[12px] shadow-2xl transition-all duration-1000 delay-300 ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`}>
              <div className="absolute top-6 left-6 z-30 text-white font-medium tracking-wide">Resolve Clinical Solutions</div>
              <div className="absolute inset-0 bg-primary/5 mix-blend-multiply z-10 pointer-events-none" />
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1556888/img/clinical_therapy_session_vertical.png" alt="Professional clinical therapy session emphasizing structured recovery and documentation" className="h-full w-full object-cover object-center" />
              {}
              <div className="absolute inset-0 rounded-[12px] ring-1 ring-inset ring-white/10 z-20 pointer-events-none" />
            </div>
            
            {}
            <div className="absolute -bottom-6 -right-6 -z-10 h-full w-full rounded-[12px] border border-primary/10 bg-primary/5" />
          </div>
        </div>
      </div>
    </section>;
}